module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms31e-popup",
      "id": "hrms31e-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['240']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_codform",
      "name": "desc_codform"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.codempid) + " - " + _vm._s(_vm.popupDetail.desc_codempid))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['260']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_department",
      "name": "v_department"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_department))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['280']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_position",
      "name": "v_position"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_position))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['300']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_jobcode",
      "name": "v_jobcode"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_jobcode))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['320']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_descempmt",
      "name": "v_descempmt"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_descempmt))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['340']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_typeemp",
      "name": "v_typeemp"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_typeemp))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['270']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_dteempmt",
      "name": "v_dteempmt"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.popupDetail.v_dteempmt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['290']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtereemp",
      "name": "dtereemp"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.popupDetail.dtereemp)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['310']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_days",
      "name": "v_days"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_days))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['330']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dte_show",
      "name": "dte_show"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.popupDetail.dte_show)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['350']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "v_descpro",
      "name": "v_descpro"
    }
  }, [_vm._v(_vm._s(_vm.popupDetail.v_descpro))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df674ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms31e/popup.vue
// module id = 3996
// module chunks = 1